var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetitionFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7236 64.9127H6.73886C6.1043 64.9088 5.47736 64.7598 4.89761 64.475C4.31787 64.1903 3.79791 63.776 3.37055 63.2583C2.45758 62.1747 1.95475 60.7468 1.96514 59.2672L1.65126 12.9245L6.55148 8.2096L13.3631 1.66455H37.7236C38.3582 1.66844 38.9851 1.81746 39.5648 2.10221C40.1446 2.38695 40.6645 2.80123 41.0919 3.31891C42.0049 4.40252 42.5077 5.83046 42.4973 7.31005V59.2672C42.5077 60.7468 42.0049 62.1747 41.0919 63.2583C40.6645 63.776 40.1446 64.1903 39.5648 64.475C38.9851 64.7598 38.3582 64.9088 37.7236 64.9127Z",
    fill: "white",
    stroke: "#717070",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0345 24.4691C34.4528 24.4691 38.0345 19.8907 38.0345 14.2431C38.0345 8.59542 34.4528 4.01709 30.0345 4.01709C25.6162 4.01709 22.0345 8.59542 22.0345 14.2431C22.0345 19.8907 25.6162 24.4691 30.0345 24.4691Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.428 20.4873C34.8463 20.4873 38.428 16.9056 38.428 12.4873C38.428 8.06903 34.8463 4.4873 30.428 4.4873C26.0097 4.4873 22.428 8.06903 22.428 12.4873C22.428 16.9056 26.0097 20.4873 30.428 20.4873Z",
    stroke: "#717070",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5653 13.0991H28.286V12.1792H30.5653C31.0067 12.1792 31.3641 12.1089 31.6375 11.9683C31.911 11.8276 32.1102 11.6323 32.2352 11.3823C32.3641 11.1323 32.4286 10.8472 32.4286 10.5269C32.4286 10.2339 32.3641 9.9585 32.2352 9.70068C32.1102 9.44287 31.911 9.23584 31.6375 9.07959C31.3641 8.91943 31.0067 8.83936 30.5653 8.83936H28.5497V16.4448H27.4188V7.91357H30.5653C31.2098 7.91357 31.7547 8.0249 32.2 8.24756C32.6454 8.47021 32.9832 8.77881 33.2137 9.17334C33.4442 9.56396 33.5594 10.0112 33.5594 10.5151C33.5594 11.062 33.4442 11.5288 33.2137 11.9155C32.9832 12.3022 32.6454 12.5972 32.2 12.8003C31.7547 12.9995 31.2098 13.0991 30.5653 13.0991Z",
    fill: "#5E5E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04553 24.5879H22.1329",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04553 33.9922H35.0439",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04553 43.396H35.0439",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04553 52.7998H35.0439",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetitionFile);
export default __webpack_public_path__ + "static/media/petition-file.368cda1c583218561e634aba09670b63.svg";
export { ForwardRef as ReactComponent };